/* eslint-disable no-underscore-dangle */
/**
 * Find marker in map by id
 * @param {String} markerId
 * @returns marker properties and methods
 */
const findMarkerObject = (map, markerId) => {
  const allMapObjects = Object.keys(map._layers).map((key) => map._layers[key]);
  const visibleMarkers = allMapObjects.filter((object) => object.options?.markerId);
  return visibleMarkers.find((marker) => marker.options?.markerId === markerId);
};

module.exports = {
  findMarkerObject,
};
